'use strict';
// TODO we have 2 cookie libraries, clean it up.
var cookie = require('js-cookie');

module.exports = function(window) {
  var tmstage = cookie.get('tmstage');
  var style="background-color:#d0006f;position:absolute;top:0;right:0;z-index:999";
  var doc = window.document;

  if (tmstage) {
    let el = doc.createElement('div');
    let txt;
    let tmenv = tmstage.match(/^[A-Z]+/);
    el.setAttribute('style', style + ';height:1px;width:100%');

    if (tmenv) {
      tmenv = tmenv[0];
      txt = doc.createElement('div');
      txt.innerHTML = tmenv;
      txt.setAttribute('style', style + ';padding:2px 4px;font-weight:bold;color:white');
      el.appendChild(txt);
    }

    doc.body.appendChild(el);

    if (txt && txt.addEventListener) {
      txt.addEventListener('mouseover', function() {
        genLocation(txt,window,doc);
      })
    }
  }
};

function genLocation(el,w,d) {
  var w = Math.max(d.documentElement.clientWidth, w.innerWidth || 0);
  var x = Math.ceil(Math.random() * (w - 50));

  el.style.right = x+'px';
}